import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StepDateTime from './eventstepper/StepDateTime';
import StepPlace from './eventstepper/StepPlace';
import StepInfo from './eventstepper/StepInfo';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import srvEvents from '../services/srv-events';


function getSteps() {
    const stepLabels = [];
    stepLabels[0] = <span>Data e Ora <i className="far fa-calendar-alt"></i></span>;
    stepLabels[1] = <span>Luogo <i className="fas fa-map-marker"></i></span>;
    stepLabels[2] = <span>Info <i className="fas fa-info-circle"></i></span>;
    return stepLabels;
}

function getStepContent(step, event, returnfnc) {
    switch (step) {
        case 0:
            return <StepDateTime event={event} returnfnc={returnfnc}></StepDateTime>;
        case 1:
            return <StepPlace event={event} returnfnc={returnfnc}></StepPlace>;
        case 2:
            return <StepInfo event={event} returnfnc={returnfnc}></StepInfo>;
        default:
            return 'Unknown step';
    }
}

class EventEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { activeStep: 0, event: this.props.event, disablenextbtn:true };
        this.handleStepCompleted = this.handleStepCompleted.bind(this);
        this.SaveEvent = this.SaveEvent.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.event.id !== this.props.event.id) {
            this.setState({ event: nextProps.event })
        }
    }

    handleStepCompleted(currentevent) {
        console.log("Current event: ", currentevent);
        this.setState({ event: currentevent, disablenextbtn:false });
    }

    SaveEvent(){
        return srvEvents.addEvent(this.state.event,"matteo");
    }

    handleNext = () => {
        this.setState({
            activeStep: this.state.activeStep + 1,
            disablenextbtn:true
        });
    };

    handleBack = () => {
        this.setState({
            activeStep: this.state.activeStep - 1,
        });
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    render() {
        //const { classes } = this.props;
        const steps = getSteps();
        const { activeStep } = this.state;

        return (
            <div className="row">
                <div className="col-12">
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((label, index) => {
                            return (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                    <StepContent>
                                        {getStepContent(index, this.state.event, this.handleStepCompleted)}
                                        <div>
                                            <div>
                                                <div className="row text-center mt-5">
                                                    <div className="col-12">
                                                        <button type="button" className="btn btn-outline-default waves-effect" disabled={activeStep === 0} onClick={this.handleBack}>Indietro</button>
                                                        <button type="submit" className="btn accent-bkg waves-effect"  onClick={activeStep === steps.length - 1 ? this.SaveEvent : this.handleNext} disabled={this.state.disablenextbtn}>{activeStep === steps.length - 1 ? 'Salva' : 'Avanti'}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </StepContent>
                                </Step>
                            );
                        })}
                    </Stepper>
                    {activeStep === steps.length && (
                        <Paper square elevation={0}>
                            <Typography>All steps completed - you&quot;re finished</Typography>
                            <Button onClick={this.handleReset}>Reset</Button>
                        </Paper>
                    )}
                </div>
            </div>
        );
    }
}

EventEditor.propTypes = {
    event: PropTypes.object.isRequired,
};

export default EventEditor;


// WEBPACK FOOTER //
// ./src/components/EventEditor.js